var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { parsePhoneNumber } from 'awesome-phonenumber';
import i18next from 'i18next';
import { merge } from 'lodash';
import isEmail from 'validator/lib/isEmail';
import * as yup from 'yup';
import { en, fr } from 'yup-locales';
var localeMap = {
    fr: fr,
    en: en,
};
var customLocale = {
    mixed: {
        required: 'required',
        notType: 'invalid',
    },
    string: {
        email: 'invalid',
    },
};
export var changeYupLocale = function (language) {
    var locale = localeMap[language] || localeMap.en;
    yup.setLocale(__assign({}, merge({}, locale, customLocale)));
};
var SPECIAL_CHARACTER_REGEX = /^[^\\/*?:[\]]*$/;
var QUOTES_NOT_ALLOWED_REGEX = /^'|'$|^"|"$/g;
var NORMALIZE_SPACE_REGEX = /\s+/g;
var FORM_FIELD = {
    Value: 'Value',
    Name: 'Name',
    Email: 'Email',
    Phone: 'Phone',
    Code: 'Code',
};
yup.setLocale({
    mixed: {
        required: 'required',
        notType: 'invalid',
    },
    string: {
        email: 'invalid',
    },
});
yup.addMethod(yup.string, 'specialCharacter', function specialCharacter(message) {
    if (message === void 0) { message = 'specialCharacter'; }
    return this.matches(SPECIAL_CHARACTER_REGEX, { message: message });
});
yup.addMethod(yup.string, 'quotesNotAllowed', function quotesNotAllowed(message) {
    if (message === void 0) { message = 'quotesNotAllowed'; }
    return this.test('quotesNotAllowed', message, function (value) { return !(value === null || value === void 0 ? void 0 : value.match(QUOTES_NOT_ALLOWED_REGEX)); });
});
yup.addMethod(yup.string, 'email', function (message) {
    if (message === void 0) { message = 'invalid'; }
    return this.test({
        message: message,
        test: function (value) { return !value || isEmail(value); },
    });
});
yup.addMethod(yup.string, 'phone', function (message) {
    if (message === void 0) { message = 'invalid'; }
    return this.test({
        message: message,
        test: function (value) {
            if (!value) {
                return true;
            }
            try {
                var pn = parsePhoneNumber(value);
                return pn.valid;
            }
            catch (_a) {
                return false;
            }
        },
    });
});
yup.addMethod(yup.string, 'uniqueBusinessAreaValidation', function (queueNames, message) {
    if (message === void 0) { message = 'duplicated'; }
    return this.test('unique', message, function (value, context) {
        var _a, _b, _c;
        var path = context.path;
        var multiSkillGroups = ((_a = context.from) === null || _a === void 0 ? void 0 : _a[1].value).multiSkillGroups;
        var currentIndex = Number.parseInt((_c = (_b = /\d+/.exec(path)) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : '-1', 10);
        var isUniqueInSingleSkills = !queueNames.includes(value || '');
        return (isUniqueInSingleSkills &&
            !multiSkillGroups
                .filter(function (group, index) { return index !== currentIndex && !!group.children.length; })
                .some(function (group) { return group.businessArea.trim() === value; }));
    });
});
yup.addMethod(yup.array, 'multiSkillGroupLength', function (message) {
    if (message === void 0) { message = 'multiSkillGroupLength'; }
    return this.test({
        name: 'children-length',
        message: message,
        test: function (value) { return !(value === null || value === void 0 ? void 0 : value.length) || value.length > 1; },
    });
});
yup.addMethod(yup.array, 'atLeastOpen', function (closedText, message) {
    if (message === void 0) { message = 'atLeastOpen'; }
    return this.test({
        name: 'at-least-open',
        message: message,
        test: function (arr) { return !arr || arr.some(function (wat) { return wat.openTime !== closedText; }); },
    });
});
yup.addMethod(yup.string, 'normalizeSpace', function () {
    return this.transform(function (value) { var _a; return (_a = value === null || value === void 0 ? void 0 : value.trim()) === null || _a === void 0 ? void 0 : _a.replaceAll(NORMALIZE_SPACE_REGEX, ' '); });
});
var formatError = yup.ValidationError.formatError;
yup.ValidationError.formatError = function (message, params) {
    if (params.label) {
        var label = params.label;
        params.label = i18next.t("formField.".concat(label)) || label;
    }
    else {
        params.label = i18next.t('formField.Value');
    }
    return formatError.call(this, message, params);
};
export default yup;
